import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';

import { HHInput } from './fields';
import { FORM_NAME } from '../forms/formConstant';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) => Yup.object().shape({
    title: Yup.string().max(64, translate('form.error.string.max')),
    location: Yup.string().max(128, translate('form.error.string.min'))
  }),
  mapPropsToValues: () => ({
    title: '',
    location: ''
  }),
  handleSubmit: (values, { props }) => {
    props.handleSubmit(values);
  },
  displayName: FORM_NAME.SEARCH_POSTING_FORM
});

const SearchPostingsForm = ({ handleSubmit, translate }) => (
  <Form className='posting-search-form' onSubmit={handleSubmit}>
    <Form.Field className='posting-search-form-keyword'>
      <Field
        name='title'
        component={HHInput}
        otherProps={{
          type: 'text',
          maxLength: 64,
          placeholder: translate('search job title')
        }}
      />
    </Form.Field>
    <Form.Field className='posting-search-form-location'>
      <Field
        name='location'
        component={HHInput}
        otherProps={{
          type: 'text',
          maxLength: 128,
          placeholder: translate('search location')
        }}
      />
    </Form.Field>
    <Form.Field className='posting-search-form-btn'>
      <Button type='submit' fluid />
    </Form.Field>
  </Form>
);

export default compose(
  withLocalize,
  formikEnhancer,
)(SearchPostingsForm);



// WEBPACK FOOTER //
// ./src/components/forms/searchPostingsForm.js